module.exports = __webpack_public_path__ + "4ab38e129b5bdbe1f71f0d63885f3282.svg";